import React, { useEffect, useState } from 'react';

import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import { fetchSettings } from '../api/settingsApi';
import { HEADER_LINKS, HEADER_OTHER_LINKS, MAX_HOUR_INFO_MESSAGE_DISABLE, IMPERSONATION_ADMIN_TOKEN_KEY } from '../shared/constants.js';
import { useSearchStringStore } from '../store/SearchString.js';
import { useFavoriteProductsStore } from '../store/FavoriteProducts.js';
import { useNotificationsStore } from '../store/Notifications.js';
import { useBasketStore } from '../store/Basket.js';
import Basket from './Basket.js';
import shoppingCartIcon from '../assets/images/shopping-cart.png';

const Header = () => {
  const [user, setUser] = useState({});
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const notificationsUnread = useNotificationsStore(state => state.notificationsUnread);
  const loadNotificationsCount = useNotificationsStore(state => state.loadNotificationsCount);
  const [showModal, setShowModal] = useState(false);
  const [showNavbar, setShowNavbar] = useState("");
  const favoriteProductsCount = useFavoriteProductsStore(state => state.favoriteProductsCount);
  const loadFavoriteProductsCount = useFavoriteProductsStore(state => state.loadFavoriteProductsCount);
  const cartProducts = useBasketStore(state => state.products);
  const cartProductsCount = cartProducts.length;
  const Toggle = () => setShowModal(!showModal);

  const [alertMessage, setAlertMessage] = useState('');
  const [showInfoMessage, setShowInfoMessage] = useState({
    value: true,
    dateAdded: null,
  });

  const searchString = useSearchStringStore(state => state.searchString);
  const setSearchString = useSearchStringStore(state => state.setSearchString);

  const [isImpersonating, setIsImpersonating] = useState(false);
  const history = useHistory();

  useEffect(() => {
    setIsImpersonating(!!sessionStorage.getItem(IMPERSONATION_ADMIN_TOKEN_KEY));
  }, []);
   
  useEffect(() => {
    const token = localStorage.getItem('token');
    const showInfoMessage = JSON.parse(localStorage.getItem('showInfoMessage'));
    if (showInfoMessage && !showInfoMessage.value) {
      if (Math.abs(Date.now() - showInfoMessage.dateAdded) / 36e5 > MAX_HOUR_INFO_MESSAGE_DISABLE) {
        localStorage.removeItem('showInfoMessage');
      } else {
        setShowInfoMessage({
          value: false,
        });
      }
    }

    fetchSettings(['alert_message']).then(data => {
      if (data && data['alert_message']) {
        setAlertMessage(data['alert_message']);
      }
    }).catch(error => {
      console.error('Error fetching alert message:', error);
    });

    if (!token) {
      return;
    }
    
    // Завантажуємо дані про користувача та обрані товари паралельно
    const userPromise = axios
      .get('/api/v1/auth/current-user', {
        headers: {
          Authorization: token,
        },
      })
      .then(res => {
        if (res.status === 200) {
          setUser(res.data.data);
          setIsLoggedIn(true);
        }
      }).catch(function(error) {
    });
    
    // Завантажуємо кількість обраних товарів та сповіщень одразу, якщо є токен
    loadFavoriteProductsCount();
    loadNotificationsCount();
    
    // Чекаємо на завершення обох запитів
    Promise.all([userPromise]);
  }, [loadFavoriteProductsCount, loadNotificationsCount]);

  // Оновлюємо кількість обраних товарів та сповіщень при поверненні на сторінку
  useEffect(() => {
    const handleFocus = () => {
      if (isLoggedIn) {
        loadFavoriteProductsCount();
        const token = localStorage.getItem('token');
        if (token) {
          loadNotificationsCount();
        }
      }
    };

    window.addEventListener('focus', handleFocus);
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [isLoggedIn, loadFavoriteProductsCount, loadNotificationsCount]);

  const handleChange = searchString => {
    if (searchString.target.value === '') {
      setSearchString('');
      history.push("/boxes");
    }

    setSearchString(searchString.target.value);
  };

  const searchByName = event => {
    if (event !== null) {
      event.preventDefault();
    }
    hideNavbar();
    history.push("/boxes?searchString=" + searchString);
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter') {
      searchByName(null);
    }
  };
  
  const hideInfoMessage = () => {
    const showInfoMessage = {
      value: false,
      dateAdded: Date.now(),
    };
    localStorage.setItem('showInfoMessage', JSON.stringify(showInfoMessage));
  };

  const clearFavorites = useFavoriteProductsStore(state => state.clearFavorites);
  
  const logoutUser = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
    useNotificationsStore.getState().setNotificationsUnread(0);
    clearFavorites();
  };

  const exitImpersonation = () => {
    const adminToken = sessionStorage.getItem(IMPERSONATION_ADMIN_TOKEN_KEY);
    if (adminToken) {
      localStorage.setItem('token', adminToken);
      sessionStorage.removeItem(IMPERSONATION_ADMIN_TOKEN_KEY);
      setIsImpersonating(false);
      history.push('/admin/users');
      window.location.reload();
    }
  };

  const hideNavbar = () => {
    setShowNavbar("");
  }

  const clickNavbarMenu = () => {
    if (showNavbar === 'show') {
      setShowNavbar("");
    } else {
      setShowNavbar("show");
    }
  }

  const renderAuthorizationLink = (withIcon=false) => {
    if (isLoggedIn) {
      return (
          <div className='col-1 d-none d-lg-block'>
            <li className='nav-item dropdown list-style-none'>
              <a
                  className='nav-link dropdown-toggle link-black'
                  href='#'
                  id='navbarDropdown'
                  role='button'
                  data-toggle='dropdown'
                  aria-haspopup='true'
                  aria-expanded='false'
              >
                <i className='bi bi-person-check-fill fa-lg'></i>
              </a>
              <div className='dropdown-menu dropdown-menu-right' aria-labelledby='navbarDropdown'>
                <Link className='dropdown-item' to='/user/personal-cabinet'>
                  Персональний кабінет
                </Link>
                <button className='dropdown-item' onClick={() => logoutUser()}>
                  Вийти з аккаунту
                </button>
              </div>
            </li>
          </div>
      );
    }
    return (
        <div className='col-1'>
          <li className='nav-item dropdown list-style-none'>
            <a
                className='nav-link dropdown-toggle link-black'
                href='#'
                id='navbarDropdown'
                role='button'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
            >
              {withIcon ? <i className='bi bi-person-circle fa-lg'></i> : <>Авторизуватись</>}
            </a>
            <div className='dropdown-menu dropdown-menu-right' aria-labelledby='navbarDropdown'>
              <Link className='dropdown-item' to='/login'>
                Увійти
              </Link>
              <Link className='dropdown-item' to='/signup'>
                Зареєструватись
              </Link>
            </div>
          </li>
        </div>
    );
  };

  const renderMobileAdminUrls = () => {
    if (isLoggedIn && user.type === 'ADMIN') {
      return (
        <div className='d-lg-none'>
          <div>
            <li className='nav-item dropdown list-style-none'>
              <a
                className='nav-link dropdown-toggle'
                href='#'
                id='navbarDropdown'
                role='button'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
              >
                <i className='bi bi-gear-wide-connected fa-lg pr-1'></i>
                Адмінка
              </a>
              <div className='dropdown-menu' aria-labelledby='navbarDropdown'>
                <Link className='dropdown-item' to='/admin/users'>
                  Користувачі
                </Link>
                <Link className='dropdown-item' to='/admin/orders/new'>
                  Замовлення
                </Link>
                <Link className='dropdown-item' to='/admin/products?page=1&state=ACTIVE'>
                  Товари
                </Link>
                <Link className='dropdown-item' to='/admin/promo-codes'>Промокоди</Link>
                <Link className='dropdown-item' to='/admin/procurement'>
                  Товари до замовлення
                </Link>
                <Link className='dropdown-item' to='/admin/supplier-stock'>
                  Прайс постачальника
                </Link>
                <Link className='dropdown-item' to='/admin/barcodes'>
                  Штрихкоди
                </Link>
                <Link className='dropdown-item' to='/admin/bank-accounts'>
                  Рахунки
                </Link>
                <Link className='dropdown-item' to='/admin/payments?page=1&status=PENDING&status=PARTIALLY_USED&type=IN'>
                  Оплати
                </Link>
                <Link className='dropdown-item' to='/admin/incoming-shipments'>
                  Поставки
                </Link>
                <Link className='dropdown-item' to='/admin/files'>
                  Дії з файлами
                </Link>
              </div>
            </li>
          </div>

          <hr className='dropdown-divider' />
        </div>
      );
    }
  };

  const renderAuthorizationLinkMobile = () => {
    if (isLoggedIn) {
      return (
          <li className='nav-item dropdown list-style-none'>
            <a
                className='nav-link dropdown-toggle'
                href='#'
                id='navbarDropdown'
                role='button'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
            >
              <i className='bi bi-person-check-fill fa-lg pr-1'></i>
              Ви авторизовані
            </a>
            <div className='dropdown-menu' aria-labelledby='navbarDropdown'>
              <Link className='dropdown-item' to='/user/personal-cabinet'>
                Персональний кабінет
              </Link>
              <button className='dropdown-item' onClick={() => logoutUser()}>
                Вийти з аккаунту
              </button>
            </div>
          </li>
      );
    }
    return (
        <li className='nav-item dropdown list-style-none'>
          <a
              className='nav-link dropdown-toggle'
              href='#'
              id='navbarDropdown'
              role='button'
              data-toggle='dropdown'
              aria-haspopup='true'
              aria-expanded='false'
          >
            <i className='bi bi-person-circle fa-lg pr-1'></i>
            Авторизуватись
          </a>
          <div className='dropdown-menu' aria-labelledby='navbarDropdown'>
            <Link className='dropdown-item' to='/login'>
              Увійти
            </Link>
            <Link className='dropdown-item' to='/signup'>
              Зареєструватись
            </Link>
          </div>
        </li>
    );
  };

  const renderAdminUrls = () => {
    if (isLoggedIn && user.type === 'ADMIN') {
      return (
        <div className='collapse navbar-collapse px-3'>
          <div className='dropdown'>
            <button
              className='btn btn-secondary dropdown-toggle'
              type='button'
              id='dropdownMenuButton'
              data-toggle='dropdown'
              aria-haspopup='true'
              aria-expanded='false'
            >
              Адмінка
            </button>
            <div className='dropdown-menu' aria-labelledby='dropdownMenuButton'>
              <Link className='nav-link' to='/admin/users'>
                Користувачі
              </Link>
              <Link className='nav-link' to='/admin/orders/new'>
                Замовлення
              </Link>
              <Link className='nav-link' to='/admin/products?page=1&state=ACTIVE'>
                Товари
              </Link>
              <Link className='nav-link' to='/admin/promo-codes'>Промокоди</Link>
              <Link className='nav-link' to='/admin/procurement'>
                Товари до замовлення
              </Link>
              <Link className='nav-link' to='/admin/supplier-stock'>
                Прайс постачальника
              </Link>
              <Link className='nav-link' to='/admin/barcodes'>
                Штрихкоди
              </Link>
              <Link className='nav-link' to='/admin/bank-accounts'>
                Рахунки
              </Link>
              <Link className='nav-link' to='/admin/payments?page=1&status=PENDING&status=PARTIALLY_USED&type=IN'>
                Оплати
              </Link>
              <Link className='nav-link' to='/admin/incoming-shipments'>
                Поставки
              </Link>
              <Link className='nav-link' to='/admin/files'>
                Файли
              </Link>
            </div>
          </div>
        </div>
      );
    }
  };

  const returnBasket = () => { 
    setShowModal(true);
  };

  return (
    <div>

      {isImpersonating && (
        <div className="alert alert-warning py-2 mb-0 rounded-0 d-flex justify-content-between align-items-center" role="alert">
          <span>Ви переглядаєте сайт від імені користувача.</span>
          <button type="button" className="btn btn-sm btn-outline-dark" onClick={exitImpersonation}>
            Повернутися в адмінку
          </button>
        </div>
      )}

      {alertMessage && showInfoMessage.value ? (
        <div className='alert alert-secondary alert-server py-1 text-center' role='alert'>
          <button
            type='button'
            className='close'
            data-dismiss='alert'
            onClick={() => hideInfoMessage()}
          >
            ×
          </button>
          <div
            dangerouslySetInnerHTML={{
              __html: alertMessage,
            }}
          />
        </div>
      ) : null}

      <header className='pt-2 pb-2 bg-light d-none d-lg-block'>
        <div className='d-flex flex-row align-items-center'>
          <div className='col-md-2 col-lg-2 d-none d-sm-block'>
            <Link className='navbar-brand link-black' to='/boxes/'>
              <strong>Wargame Shop </strong>
            </Link>
          </div>

          <div className='col-xl-5 col-md-4 row place-content-center d-none d-md-block'>
            <div className='d-flex flex-row align-items-center'>
              <input
                className='form-control'
                type='search'
                value={searchString}
                onChange={event => handleChange(event)}
                placeholder='Пошук по назві'
                onKeyDown={(event) => handleKeyDown(event)}
              />
              <button className='btn btn-dark ml-2 mr-4 d-none d-lg-block' onClick={event => searchByName(event)}>
                Шукати
              </button>
              <i onClick={event => searchByName(event)} className="bi bi-search fa-lg ml-2 d-block d-lg-none" style={{color: 'white'}}></i>
            </div>
          </div>


          <div className='d-flex flex-column col-xl-2 col-md-3 pl-0i'>
            <div><i className="bi bi-clock-fill"></i> Працюємо щоденно:</div>
            <div className="pl-4 d-flex"><strong>Пн-Пт:</strong> <div className="pl-2 fs-6">9:00 – 19:00</div></div>
            <div className="pl-4 d-flex"><strong>Сб-Нд:</strong> <div className="pl-2">9:00 – 15:00</div></div>
          </div>

          <a
              className='nav-link'
              href="https://t.me/waaaghShopAdmin" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-telegram fa-lg"></i>
          </a>
          <div className='col col-sm-3 col-md-2 align-items-end pl-1 ml-0'>
            <i className="bi bi-telephone-fill fa-lg"></i> 093-553-5116
          </div>

          {renderAuthorizationLink(true)}

        </div>
      </header>

      <nav className='navbar navbar-expand-lg navbar-dark bg-dark'>
        <button
          className='navbar-toggler'
          type='button'
          onClick={() => clickNavbarMenu()}
        >
          <span className='navbar-toggler-icon'></span>
        </button>

        <Link className='col text-center navbar-brand d-block d-lg-none pr-0' to='/'>Wargame Shop</Link>

        <div className='d-flex align-items-center'>
          {isLoggedIn && notificationsUnread > 0 && (
            <Link
              to='/user/personal-cabinet?tab=notifications'
              className='btn d-block d-lg-none mr-2'
              style={{ position: 'relative', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px' }}
            >
              <i className='bi bi-bell-fill' style={{ fontSize: '1.15rem', color: '#fff', opacity: 0.9 }}></i>
              <span
                className='badge badge-danger'
                style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-5px',
                  fontSize: '0.65rem',
                  padding: '0.15rem 0.35rem',
                  borderRadius: '10px'
                }}
              >
                {notificationsUnread > 9 ? '9+' : notificationsUnread}
              </span>
            </Link>
          )}
          {isLoggedIn && (
            <Link 
              to='/user/personal-cabinet?tab=favorites' 
              className='btn d-block d-lg-none mr-2'
              style={{ position: 'relative', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px' }}
            >
              <i className='bi bi-heart-fill' style={{ fontSize: '1.15rem', color: '#dc3545', opacity: 0.8 }}></i>
              {favoriteProductsCount > 0 && (
                <span 
                  className='badge badge-danger'
                  style={{
                    position: 'absolute',
                    top: '-8px',
                    right: '-5px',
                    fontSize: '0.65rem',
                    padding: '0.15rem 0.35rem',
                    borderRadius: '10px'
                  }}
                >
                  {favoriteProductsCount}
                </span>
              )}
            </Link>
          )}

          <button 
            className='btn d-block d-lg-none' 
            onClick={() => returnBasket()}
            style={{ position: 'relative', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px' }}
          >
            <img src={shoppingCartIcon} alt='basket' style={{ width: '28px', height: '28px' }} />
            {cartProductsCount > 0 && (
              <span 
                className='badge badge-primary'
                style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-5px',
                  fontSize: '0.65rem',
                  padding: '0.15rem 0.35rem',
                  borderRadius: '10px',
                  backgroundColor: '#007bff'
                }}
              >
                {cartProductsCount}
              </span>
            )}
          </button>
        </div>

        <div className={"collapse navbar-collapse " + showNavbar} id='navbarTogglerDemo01'>

          <div className='col row place-content-center d-block d-lg-none mt-4 mb-4'>
            <div className='d-flex flex-row align-items-center'>
            <input
              className='form-control'
              type='search'
              value={searchString}
              onChange={event => handleChange(event)}
              placeholder='Пошук по назві'
              onKeyDown={(event) => handleKeyDown(event)}
            />
            <button className='btn btn-dark ml-2 mr-4 d-none d-lg-block' onClick={event => searchByName(event)}>
              Шукати
            </button>
            <i onClick={event => searchByName(event)} className="bi bi-search fa-lg ml-2 d-block d-lg-none" style={{color: 'white'}}></i>
          </div>
          </div>

          <hr className="dropdown-divider"/>

          <ul className='nav-item dropdown navbar-nav mr-auto'>
            {HEADER_LINKS.map(link => (
              <li key={link.url} className='nav-item active'>
                <Link className='nav-link' to={link.url} onClick={() => hideNavbar()}>
                  {link.text}
                </Link>
              </li>
            ))}

            <li className='nav-item active dropdown'>
              <a
                className='nav-link dropdown-toggle'
                href='#'
                id='navbarDropdownMenuLink'
                data-toggle='dropdown'
                aria-haspopup='true'
                aria-expanded='false'
              >
                Інше
              </a>
              <div className='dropdown-menu' aria-labelledby='navbarDropdownMenuLink'>
                {HEADER_OTHER_LINKS.map((button, index) => (
                    <Link className="dropdown-item" key={index} to={button.link} onClick={() => hideNavbar()}> {button.text} </Link>
                ))}
              </div>
            </li>

            <div className='d-lg-none'>
              <hr className='dropdown-divider' />
              {renderAuthorizationLinkMobile()}
              <hr className='dropdown-divider' />
            </div>

            {renderMobileAdminUrls()}

            <div className='d-lg-none'>
              <span className='nav-link py-1 my-0'>
                <i className="bi bi-clock-fill pr-1"></i>
                Графік роботи:
                <span className='d-block'><strong>Пн-Пт:</strong> 9:00 – 19:00</span>
                <span className='d-block'><strong>Сб-Нд:</strong> 9:00 – 15:00</span>
              </span>
            </div>

            <div className='d-lg-none'>
              <hr className='dropdown-divider' />
            </div>

            <h5 className='d-lg-none nav-link py-1 my-0'>
              Контакти:
            </h5>
            <div className='d-lg-none'>
              <a
                className='nav-link'
                href="http://t.me/waaaghShopAdmin" target="_blank" rel="noopener noreferrer">
                <i className="bi bi-telegram fa-lg pr-1"></i>
                Ми в Telegram
                </a>
            </div>

            <div className='d-lg-none'>
              <span className='nav-link'>
                <i className="bi bi-telephone-fill fa-lg pr-1"></i>
                093-553-5116
              </span>
            </div>
          </ul>
        </div>

        {isLoggedIn && notificationsUnread > 0 && (
          <Link
            to='/user/personal-cabinet?tab=notifications'
            className='btn d-none d-lg-block mr-2'
            style={{ position: 'relative', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px' }}
          >
            <i className='bi bi-bell-fill' style={{ fontSize: '1.15rem', color: '#fff', opacity: 0.9 }}></i>
            <span
              className='badge badge-danger'
              style={{
                position: 'absolute',
                top: '-8px',
                right: '-5px',
                fontSize: '0.65rem',
                padding: '0.15rem 0.35rem',
                borderRadius: '10px'
              }}
            >
              {notificationsUnread > 9 ? '9+' : notificationsUnread}
            </span>
          </Link>
        )}
        {isLoggedIn && (
          <Link 
            to='/user/personal-cabinet?tab=favorites' 
            className='btn d-none d-lg-block mr-2'
            style={{ position: 'relative', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px' }}
          >
            <i className='bi bi-heart-fill' style={{ fontSize: '1.15rem', color: '#dc3545', opacity: 0.8 }}></i>
            {favoriteProductsCount > 0 && (
              <span 
                className='badge badge-danger'
                style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-5px',
                  fontSize: '0.65rem',
                  padding: '0.15rem 0.35rem',
                  borderRadius: '10px'
                }}
              >
                {favoriteProductsCount}
              </span>
            )}
          </Link>
        )}

        <button 
          className='btn d-none d-lg-block' 
          onClick={() => returnBasket()}
          style={{ position: 'relative', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '28px', height: '28px' }}
        >  
          <img src={shoppingCartIcon} alt='basket' style={{ width: '28px', height: '28px' }} />
          {cartProductsCount > 0 && (
            <span 
              className='badge badge-primary'
              style={{
                position: 'absolute',
                top: '-8px',
                right: '-5px',
                fontSize: '0.65rem',
                padding: '0.15rem 0.35rem',
                borderRadius: '10px',
                backgroundColor: '#007bff'
              }}
            >
              {cartProductsCount}
            </span>
          )}
        </button>

        {renderAdminUrls()}

      </nav>
      

       <Basket showModal={showModal} close={Toggle} />
    </div>
  );
};

export default Header;
